<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9unY0Y/tc-custom/9781644033029.jpg?1737197407729" alt="This image is the cover for the book Quilter's 2-1/2" Strip Precut Companion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quilter's 2-1/2" Strip Precut Companion
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Sewing with precut strips makes quilting a snap! Your favorite jelly rolls plus easy-to-follow patterns equal a beautiful handmade quilt in no time.</b></p><p>Master the use of 2 1/2”-wide precut strips with these delightful blocks, all featuring Jelly Rolls. Precut strips are perfect for beginners because they’re incredibly easy to work with and versatile. If you’re new to quilting, start here, and you’ll be amazed at what you can do with just one roll.</p>This book contains 20 quilt blocks and patterns with accompanying quilts! Go beyond the Jelly Roll Race! Make dynamic and fun blocks with 2 1/2”-wide strips 20 blocks ideal for Jelly Roll, Rolie Polies, and Bali Pops hand-selected by the precut experts at Missouri Star Quilt Company 20 quilts for 20 blocks! Each block as an accompanying quilt; yardage and instructions included
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenny Doan
      </h2>
      
      <p class="authorDescription body article">Jenny Doan, star of the MissouriQuiltCo YouTube channel, is beloved for her approachable demeanor and contagious enthusiasm for quilting. Jenny and her husband live in the small town of Hamilton, Missouri, where they run Missouri Star Quilt Co. with several of their children. missouriquiltco.com; blog.missouriquiltco.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d78f201